import { Alert } from 'src/design/atoms/Alert';
import { Divider } from 'src/design/atoms/Divider';
import { Group } from 'src/design/atoms/Group';
import { Paper } from 'src/design/atoms/Paper';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Title } from 'src/design/atoms/Title';
import React from 'react';
import {
  useSendTestEmail,
  useSendTestTimesheetEmail,
} from 'src/api/queries/admin/useHealthcheck';
import { BasicButton } from 'src/design/atoms/BasicButton';
import { getErrorMessage } from 'src/utils';

export const SendTestEmailPanel: React.FC = () => {
  const [error, setError] = React.useState<string | null>(null);
  const [success, setSuccess] = React.useState<string | null>(null);
  const sendTestEmail = useSendTestEmail();
  const sendTestTimesheetEmail = useSendTestTimesheetEmail();
  const loading = sendTestEmail.isPending || sendTestTimesheetEmail.isPending;

  const reset = () => {
    setError(null);
    setSuccess(null);
  };

  const sendEmail = () => {
    reset();
    sendTestEmail.mutate(undefined, {
      onSuccess: () =>
        setSuccess(
          'Test email sent successfully. Check your inbox for the test email.',
        ),
      onError: (err) =>
        setError(`Failed to send test email: ${getErrorMessage(err)}`),
    });
  };

  const sendTimesheetEmail = () => {
    reset();
    sendTestTimesheetEmail.mutate(undefined, {
      onSuccess: () =>
        setSuccess(
          'Test timesheet email sent successfully. Check your inbox for the test email.',
        ),
      onError: (err) =>
        setError(
          `Failed to send test timesheet email: ${getErrorMessage(err)}`,
        ),
    });
  };

  return (
    <Paper withBorder p="md">
      <Stack gap="md">
        <Title order={4}>Email</Title>
        <Text>Send a test email to verify outbound email configuration.</Text>
        <Group gap="xs">
          <BasicButton
            onClick={sendEmail}
            loading={loading}
            size="sm"
            w="fit-content"
          >
            Send Test Email
          </BasicButton>
          <Divider orientation="vertical" />

          <BasicButton
            onClick={sendTimesheetEmail}
            loading={loading}
            size="sm"
            w="fit-content"
          >
            Send Test Timesheet Email
          </BasicButton>
        </Group>
        {error && (
          <Alert color="red" title="Error" variant="light">
            {error}
          </Alert>
        )}
        {success && (
          <Alert color="green" title="Success" variant="light">
            {success}
          </Alert>
        )}
      </Stack>
    </Paper>
  );
};
